import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { V2Sidebar } from "@/v2/components/Sidebar";
import { V2TopBar } from "@/v2/components/TopBar";
import { CommandPalette } from "@/v2/components/CommandPalette";
import { AIAssistant } from "@/v2/components/AIAssistant";
import { ImpersonationBanner } from "@/v2/components/ImpersonationBanner";
import { useLocalPref } from "@/v2/hooks/useLocalPref";
import "@/v2/theme.css";

export function V2AppShell() {
  const [collapsed, setCollapsed] = useLocalPref("zj_v2_sidebar_collapsed", false);
  const [theme, setTheme] = useLocalPref("zj_v2_theme_v3", "light");
  const [paletteOpen, setPaletteOpen] = useState(false);

  // Global ⌘K
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Ensure root has dark class for shadcn compatibility
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <div
      className={`zj-v2 ${theme === "dark" ? "v2-dark" : "v2-light"}`}
      style={{ display: "flex", minHeight: "100vh", background: "var(--v2-bg)" }}
      data-testid="v2-app-shell"
    >
      <V2Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <ImpersonationBanner />
        <V2TopBar
          collapsed={collapsed}
          onToggleSidebar={() => setCollapsed((v) => !v)}
          onOpenPalette={() => setPaletteOpen(true)}
          theme={theme}
          onToggleTheme={toggleTheme}
        />
        <main style={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </main>
      </div>

      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <AIAssistant />
    </div>
  );
}
